import { IS_SMALL_SCREEN } from '@Constants/LeftDrawer';
import styled from 'styled-components/native';

const StyledProductCard = styled.View`
  background-color: white;
  margin: 0 16px 8px 16px;
  padding: ${IS_SMALL_SCREEN ? '10px 16px' : '16px'};
  border-radius: 16px;
`;

export default StyledProductCard;
